module.exports = __webpack_public_path__ + "media/images/official/special_workcation_05-d21eee0319bdadf9d7d07a16b4640812.jpg";